import React, { useEffect, useState } from 'react';
import { Line, Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { getDashboardStats } from '../services/dbService';
import './Dashboard.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend);

const Dashboard = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            setLoading(true);
            console.log('Fetching dashboard stats...');
            const response = await getDashboardStats();
            console.log('Dashboard stats loaded:', response);
            setStats(response);
        } catch (err) {
            console.error('Dashboard fetch error:', err);
            setError(err.message || 'Failed to fetch statistics');
        } finally {
            setLoading(false);
        }
    };

    const chartOptions = {
        responsive: true,
        plugins: { legend: { position: 'top' } },
        scales: { y: { beginAtZero: true } },
    };

    if (loading) {
        return (
            <div className="dashboard-container">
                <p>Loading statistics...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="dashboard-container">
                <p className="error">{error}</p>
            </div>
        );
    }

    const ordersChartData = {
        labels: stats?.ordersPerDay?.map((item) => item.date) || [],
        datasets: [
            {
                label: 'Orders per Day',
                data: stats?.ordersPerDay?.map((item) => item.count) || [],
                borderColor: '#667eea',
                backgroundColor: 'rgba(102, 126, 234, 0.1)',
                tension: 0.4,
            },
        ],
    };

    const revenueChartData = {
        labels: stats?.revenuePerDay?.map((item) => item.date) || [],
        datasets: [
            {
                label: 'Revenue per Day (ETB)',
                data: stats?.revenuePerDay?.map((item) => item.amount) || [],
                backgroundColor: 'rgba(72, 187, 120, 0.7)',
                borderColor: '#48bb78',
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className="dashboard-container animate-fade-in">
            <h1>Dashboard</h1>

            <div className="stats-grid">
                <div className="stat-card">
                    <div className="stat-icon">👥</div>
                    <div className="stat-content">
                        <p className="stat-label">Total Users</p>
                        <p className="stat-value">{stats?.totalUsers || 0}</p>
                    </div>
                </div>

                <div className="stat-card">
                    <div className="stat-icon">🎉</div>
                    <div className="stat-content">
                        <p className="stat-label">Total Events</p>
                        <p className="stat-value">{stats?.totalEvents || 0}</p>
                    </div>
                </div>

                <div className="stat-card">
                    <div className="stat-icon">📦</div>
                    <div className="stat-content">
                        <p className="stat-label">Total Orders</p>
                        <p className="stat-value">{stats?.totalOrders || 0}</p>
                    </div>
                </div>

                <div className="stat-card">
                    <div className="stat-icon">💰</div>
                    <div className="stat-content">
                        <p className="stat-label">Total Revenue</p>
                        <p className="stat-value">{stats?.totalRevenue?.toFixed(2) || '0.00'} ETB</p>
                    </div>
                </div>

                <div className="stat-card">
                    <div className="stat-icon">⏳</div>
                    <div className="stat-content">
                        <p className="stat-label">Pending Verification</p>
                        <p className="stat-value">{stats?.pendingVerification || 0}</p>
                    </div>
                </div>

                <div className="stat-card">
                    <div className="stat-icon">⭐</div>
                    <div className="stat-content">
                        <p className="stat-label">Avg Rating</p>
                        <p className="stat-value">{stats?.averageRating?.toFixed(2) || '0.00'}</p>
                    </div>
                </div>
            </div>

            <div className="charts-grid">
                <div className="chart-container">
                    <h2>Orders per Day</h2>
                    {stats?.ordersPerDay && stats.ordersPerDay.length > 0 ? (
                        <Line data={ordersChartData} options={chartOptions} />
                    ) : (
                        <p className="no-data">No data available</p>
                    )}
                </div>

                <div className="chart-container">
                    <h2>Revenue per Day</h2>
                    {stats?.revenuePerDay && stats.revenuePerDay.length > 0 ? (
                        <Bar data={revenueChartData} options={chartOptions} />
                    ) : (
                        <p className="no-data">No data available</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Dashboard;